import React from 'react'

import { Text } from '@wartek-id/text'
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleIcon,
  CollapsibleContent,
} from '@wartek-id/collapsible'

import type { FAQItemProps } from '../../types/faq'

const FAQ5 = (props: FAQItemProps) => {
  return (
    <Collapsible {...props}>
      <CollapsibleTrigger className="!text-left">
        <Text variant="body-sm" className="!font-semibold">
          Apa yang harus dilakukan setelah melakukan asesmen?
        </Text>
        <CollapsibleIcon></CollapsibleIcon>
      </CollapsibleTrigger>
      <CollapsibleContent className="p-4">
        <Text className="mb-6">
          Gunakan hasil asesmen sebagai <b>refleksi</b> terhadap pembelajaran,
          kemudian{' '}
          <b>
            tentukan tindak lanjut berupa perbaikan, modifikasi, ataupun
            perubahan perencanaan pembelajaran
          </b>{' '}
          yang sesuai dengan kebutuhan peserta didik.
        </Text>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default FAQ5
